import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Text from '@amzn/meridian/text';
import Row from '@amzn/meridian/row';
import { useBundle } from '@amzn/react-arb-tools';
import { AdBlock } from 'src/common/adBlock/AdBlock';
import { ProductCard } from 'src/common/productCard';
import { BouncingBox } from 'src/common/loaders';
import { DogPage } from 'src/common/errors';
import { Paragraph } from 'src/common/styled';
import { useContent } from 'src/hooks';
import { CreatorProfileCard } from '../components/CreatorProfileCard';
import { HeroContainer, HeroImage, ProductList, ProductGrid } from '../components/styled';
export const CreatorStorefrontPage = () => {
    const [bundle, isBundleLoading] = useBundle('pages.storefrontPage');
    const { data, isLoading, isError } = useContent();
    // Handle loading state
    if (isLoading || isBundleLoading) {
        return _jsx(BouncingBox, {});
    }
    // Handle error state
    if (isError || !data) {
        return _jsx(DogPage, {});
    }
    return (_jsxs(_Fragment, { children: [_jsx(CreatorProfileCard, { avatarUrl: data.creatorAvatarUrl, name: data.creatorName, isTopCreator: data.isTopCreator, creatorBadges: data.creatorBadges }), _jsx(HeroContainer, { "data-testid": "storefront-hero-container", children: _jsx(HeroImage, { src: data.contentData.contentUrl, alt: `${data.creatorName} content` }) }), _jsx(Row, { spacingInset: "400 300", children: _jsx(Paragraph, { type: "b200", children: data.contentMessage }) }), _jsx(Row, { spacingInset: "none 300", children: _jsx(Text, { type: "h200", children: bundle.getMessage('productsInThisPhoto') }) }), _jsx(ProductList, { layout: "horizontal", spacing: "400", "data-testid": "storefront-product-list", children: _jsx(ProductGrid, { columns: 1, "data-testid": "product-cards", children: data.products.map((productItem) => (_jsx(ProductCard, { productItem: productItem, layout: "horizontal" }, productItem.asin))) }) }), _jsx(AdBlock, { offRampUrl: data.viewOnAmazonUrl })] }));
};
